import React from "react";
import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react";
import { brandConfig } from "../../../brandConfig";
import { NavbarWithCallToAction } from "../../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { SEOHead } from "../../../components/SEOHead";

const PersonalAssetFinanceCalculator: React.FC = () => {
  return (
    <Box minH="100vh" bg="white">
      <SEOHead
        pagePath="/calculators/personal-asset-finance"
        fallbackTitle="Personal Asset Finance Calculator"
        fallbackDescription="Calculate financing options for personal assets"
      />
      <NavbarWithCallToAction />

      {/* Hero Section */}
      <Box bg={brandConfig.colors.primary} color="white" py={20}>
        <Container maxW="container.xl">
          <VStack spacing={6} textAlign="center">
            <Text fontSize="sm" color="rgba(255, 255, 255, 0.7)" textTransform="uppercase" letterSpacing="wider">
              Calculator Section
            </Text>
            <Heading size="2xl" fontWeight="bold">
              Personal & Asset Finance Calculator
            </Heading>
            <Text fontSize="xl" color="rgba(255, 255, 255, 0.9)" maxW="2xl">Calculate personal loan repayments</Text>
          </VStack>
        </Container>
      </Box>

      {/* Content Section */}
      <Container maxW="container.xl" py={20} flex="1">
        <VStack spacing={6}>
          <Box
            p={12}
            bg="gray.50"
            borderRadius="lg"
            border="1px dashed"
            borderColor="gray.300"
            textAlign="center"
          >
            <Text color="gray.600" fontSize="lg" fontWeight={500}>
              🚧 Content Coming Soon
            </Text>
            <Text color="gray.500" fontSize="sm" mt={2}>
              This page is under construction
            </Text>
          </Box>
        </VStack>
      </Container>

      <FooterWithFourColumns />
    </Box>
  );
};

export default PersonalAssetFinanceCalculator;
